/**
 * created by xcc  2022/4/16
 * 媒体管理路由
 */
import MediaAdminister from "../pms/MediaAdminister";   //媒体管理
import MediaAdministerBatchAddComponent from "../pms/MediaAdministerBatchComponent";   //批量新增

export  const  mediaAdministerRouter =[
    {
        path: "/view/pms/mediaAdminister",
        componentTitle:'pms媒体管理',
        component: MediaAdminister
    },
    {
        path: "/view/sys/mediaAdminister/:isSys",
        componentTitle:'sys媒体管理',
        component: MediaAdminister
    },
    {
        path: "/view/pms/mediaAdministerBatchAddComponent",
        componentTitle:'pms媒体管理批量新增',
        component: MediaAdministerBatchAddComponent
    }
];

